import { literal, string, struct } from 'io-ts/Decoder';

import { RefItem as StageRefItem } from '../stage/RefItem';

import { Id } from './Id';

export const FilterItem = struct({
	id: Id,
	name: string,
	type: literal('filter'),
	stage: StageRefItem,
});
